import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PlansService {
  plan: any = {};
  MatriPlan: any = {};
  dbPlan: any = {}
  advertsPlan: any = {}
  selectedPlan: any;

  // 🔥 This stores module like JOBS / RESUMES / MATRIMONY / ADS
  public selectedModule: string = 'JOBS';

  private selectedPlanIdSource = new BehaviorSubject<number | null>(null);
  selectedPlanId$ = this.selectedPlanIdSource.asObservable();

  planName = [
    { key: 'Free', value: 'Free' },
    { key: 'Economy', value: 'Economy' },
    { key: 'Basic', value: 'Basic' },
    { key: 'Standard', value: 'Standard' },
    { key: 'Classic', value: 'Classic' },
    { key: 'Premium', value: 'Premium' },
    { key: 'Enterprise', value: 'Enterprise' },
  ];


  constructor() { }
  getPlans() {
    return this.planName;
  }

   setSelectedPlanId(id: number) {
    this.selectedPlanIdSource.next(id);
  }
  
}
